import React, { useEffect, useState } from "react";
import { Button, Card, Typography } from "@material-tailwind/react";
import { PencilIcon, TrashIcon, PlusCircleIcon } from "@heroicons/react/24/solid";
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNewsGeneral, setLoaderVisibility } from "../../../app/actions/action-creators";
import axios from "axios";
import { API_BASE_URL } from '../../../data/static-config.js';
import parse from 'html-react-parser';

const TABLE_HEAD_EN = ["Title", "Subtitle", "Banner", "Language"];
const TABLE_HEAD_ID = ["Judu", "Subjudul", "Banner", "Bahasa"];

export function TableNewsGeneral() {
  const data = useSelector((state) => state?.combineReducer?.adminOrganizations?.news);
  const TABLE_ROWS = data?.lst;
  const token = useSelector((state) => state?.combineReducer?.adminToken?.token);
  const [isNeedRefresh, setIsNeedRefresh] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const languageCode = useSelector((state) => state?.combineReducer?.clientLanguage?.data);
  const [TABLE_HEAD, SET_TABLE_HEAD] = useState([]);

  useEffect(() => {
    languageCode == 1033 ? SET_TABLE_HEAD(TABLE_HEAD_EN) : SET_TABLE_HEAD(TABLE_HEAD_ID);
  }, [languageCode])

  useEffect(() => {
    if (data?.length === 0) {
      dispatch(setLoaderVisibility(true))
    } else {
      dispatch(setLoaderVisibility(false))
    }
  }, [data]);

  useEffect(() => {
    dispatch(getNewsGeneral({ token, languageCode }));
  }, [isNeedRefresh, languageCode]);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      dangerMode: true,
      buttons: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          dispatch(setLoaderVisibility(true))
          axios.delete(`${API_BASE_URL}/api/newsgeneral/${id}`, {
            headers: {
              access_token: token
            }
          }).then((_) => {
            dispatch(setLoaderVisibility(false))
            setIsNeedRefresh(!isNeedRefresh)
          })
        }
      });
  };

  const handleUpdate = (id) => {
    navigate(`/cms/publication/news/update/${id}`);
  };

  return (
    <>
      <Card className="w-full rounded-none">
        <table className="w-full table-auto text-left">
          <thead>
            <tr>
              {TABLE_HEAD?.map((head) => (
                <th key={head} className="border-y border-gray-400 bg-blue-gray-50/50 p-2">
                  <Typography
                    variant="small"
                    color="gray"
                    className="leading-none"
                  >
                    {head}
                  </Typography>
                </th>
              ))}
              <th className="border-y border-gray-400 bg-blue-gray-50/50 p-2">
                {
                  <ButtonAdd />
                }
              </th>
            </tr>
          </thead>
          <tbody>
            {TABLE_ROWS?.map(({ id, title, subtitle, languageCode, imgBanner }, index) => (
              <tr key={id} className="even:bg-blue-gray-50/50 hover:cursor-pointer hover:bg-blue-gray-50" >
                <td className="p-4" onClick={() => handleUpdate(id)}>
                  <Typography variant="small" color="blue-gray" className="font-normal">
                    {title}
                  </Typography>
                </td>
                <td className="p-4" onClick={() => handleUpdate(id)}>
                  <Typography variant="small" color="blue-gray" className="font-normal">
                    {subtitle ? parse(subtitle) : ""}
                  </Typography>
                </td>
                <td onClick={() => handleUpdate(id)}>
                  <img src={imgBanner} className="h-28 rounded"></img>
                </td>
                <td className="p-4" onClick={() => handleUpdate(id)}>
                  <Typography variant="small" color="blue-gray" className="font-normal">
                    {languageCode === 1033 ? "English" : "Bahasa Indonesia"}
                  </Typography>
                </td>
                <td className="p-4 h-full flex-col items-center justify-center">
                  <Button color="blue-gray" variant="solid" size="sm" className="flex items-center gap-2 m-1" onClick={() => handleUpdate(id)}>
                    <PencilIcon className="w-4" color="white" />
                    Update
                  </Button>
                  <Button color="red" variant="gradient" size="sm" className="flex items-center gap-2 m-1" onClick={() => handleDelete(id)}>
                    <TrashIcon className="w-4" />
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </>
  );
}

function ButtonAdd() {
  const navigate = useNavigate();
  const handleAdd = () => {
    navigate("/cms/publication/news/add");
  }
  return (
    <Button variant="gradient" size="sm" className="flex items-end justify-center gap-2 w-full" color="black" onClick={handleAdd}>
      <PlusCircleIcon className="w-4" />
      Add
    </Button>
  )
}